import { render, staticRenderFns } from "./ClientsView.vue?vue&type=template&id=a7fe9bfa&scoped=true"
import script from "./ClientsView.vue?vue&type=script&lang=ts"
export * from "./ClientsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7fe9bfa",
  null
  
)

export default component.exports